import { getFormattedDate } from 'utils/dateUtils';

const getLockedText = ({ isSuspended, suspendDate, isFrozen, serviceName }) => {
    if (isSuspended) {
        return `Для продолжения работы с сервисом и восстановления работоспособности всех методов пополните счёт. Если этого не произойдёт до ${suspendDate}, то все ваши данные будут удалены.`;
    }
    if (isFrozen) {
        return `Вы не можете создавать и использовать ресурсы сервиса ${serviceName}. Пополните баланс, чтобы возобновить работу.`;
    }
};

export const lockedServiceUtils = {
    getLockedText,
    getFormattedDate,
};
